import SihaUploadDocumentRequestModelBase from '../_generated/modelBases/siha-upload-document-request-model-base';

export default class SihaUploadDocumentRequestModel extends SihaUploadDocumentRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
